/* @flow */

/**
 * Replaces placeholders in template with corresponding values in context.
 * @param {string} template Template string containing placeholders
 * @param {object} context <key, value> store that might contain the values to inject in the template
 * @param {boolean} strict Strict mode flag: render the whole template with one or many missing placeholder values
 */
export default function renderTemplate(template: string, context: Object, strict?: boolean = true): string {
  const placeholders = template.match(/\{[^}]+\}/g) || [];
  let result = template;

  for (const placeholder of placeholders) {
    const contextKey = placeholder.substring(1, placeholder.length - 1);
    let valueToInject = getPropertyValue(context, contextKey);

    if (!valueToInject && strict) return '';
    if (!valueToInject) valueToInject = '';

    result = result.replace(placeholder, String(valueToInject));
  }

  return result;
}

export function getPropertyValue(o: Object, key: string): ?string | ?number {
  if (Object.keys(o).length === 0) return null;

  const expandablePaths = [];
  for (const objKey of Object.keys(o)) {
    if (Array.isArray(o[objKey])) continue;
    else if (o[objKey] && typeof o[objKey] === 'object') expandablePaths.push(o[objKey]);
    else if (objKey === key) return getValue(o, objKey);
    else continue;
  }
  for (const expandablePath of expandablePaths) {
    const result = getPropertyValue(expandablePath, key);
    if (result) return result;
  }

  return null;
}

function getValue(o: Object, objKey: string) {
  if (objKey === 'latitude' || objKey === 'longitude') {
    return getDealerCoordinateWithCardinalDirectionValue(o[objKey], objKey)
  }
  return o[objKey]
}

export function getDealerCoordinateWithCardinalDirectionValue(
  coordinateValue?: number,
  coordinateType: 'latitude' | 'longitude'): string {
  if (!coordinateValue) return '';
  return coordinateValue > 0
    ? `${coordinateType === 'latitude' ? 'N' : 'E'}${coordinateValue}`
    : `${coordinateType === 'latitude' ? 'S' : 'W'}${String(coordinateValue).slice(1)}`;
}
